import React, { useState } from 'react';
import { Info, Video as VideoIcon, Loading, Delete as DeleteIcon } from '@icon-park/react';
import { uploadFile, FILE_TYPES } from '../../api/upload';
import { formatFileSize } from '../../utils/fileUtils';
import './styles/VideoUploader.css';

function VideoUploader({ data, onUpdate }) {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [error, setError] = useState('');

  const handleVideoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setUploadProgress(0);
    setError('');

    try {
      console.log(`开始上传视频: ${file.name}, 大小: ${formatFileSize(file.size)}`);

      // 上传视频到OSS/CDN
      const videoUrl = await uploadFile(file, {
        fileType: FILE_TYPES.VIDEO,
        folder: 'labels/videos',
        onProgress: (percent) => {
          setUploadProgress(percent);
          console.log(`视频上传进度: ${percent}%`);
        }
      });

      // 更新数据（只保存URL）
      onUpdate({ 
        ...data, 
        video: { 
          url: videoUrl,  // ✅ CDN URL
          name: file.name,
          size: file.size,
          sizeFormatted: formatFileSize(file.size)
        } 
      });

      console.log('视频上传成功:', videoUrl);
    } catch (err) {
      console.error('视频上传失败:', err);
      setError(err.message || '视频上传失败，请重试');
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  const handleDeleteVideo = () => {
    onUpdate({ ...data, video: null });
  };

  return (
    <div className="video-uploader-container">
      <div className="uploader-header">
        <span className="uploader-title">选择背景颜色</span>
        <span className="info-icon"><Info theme="outline" size={14} fill="#999" strokeWidth={3} /></span>
      </div>
      
      <h3 className="section-title">视频添加</h3>
      
      {/* 错误提示 */}
      {error && (
        <div className="upload-error">
          ⚠️ {error}
        </div>
      )}

      {!data.video ? (
        <div className="upload-area-video">
          <input
            type="file"
            id="video-upload"
            accept="video/*"
            onChange={handleVideoUpload}
            disabled={uploading}
            style={{ display: 'none' }}
          />
          <label 
            htmlFor="video-upload" 
            className={`upload-box-video ${uploading ? 'uploading' : ''}`}
          >
            {uploading ? (
              <>
                <div className="upload-icon-video">
                <Loading theme="outline" size={20} fill="#2563EB" strokeWidth={3} />
                </div>
                <div className="upload-text-video">上传中... {uploadProgress}%</div>
                <div className="upload-progress-bar">
                  <div 
                    className="upload-progress-fill" 
                    style={{ width: `${uploadProgress}%` }}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="upload-icon-video">
                  <VideoIcon theme="outline" size={20} fill="#333" strokeWidth={3} />
                </div>
                <div className="upload-text-video">上传视频</div>
                <div className="upload-hint">支持MP4、MOV、AVI，最大100MB</div>
              </>
            )}
          </label>
        </div>
      ) : (
        <div className="video-preview">
          <video src={data.video.url} controls className="video-player" />
          <div className="video-info">
            <div className="video-details">
              <span className="video-name">📹 {data.video.name}</span>
              {data.video.sizeFormatted && (
                <span className="video-size">{data.video.sizeFormatted}</span>
              )}
            </div>
            <button className="delete-video-btn" onClick={handleDeleteVideo}>
              <DeleteIcon theme="outline" size={14} fill="#fff" strokeWidth={3} />
              删除
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default VideoUploader;
